import { createSelector } from 'reselect'

import { getCandidateProfile } from '../redux/modules/candidate'

export const trackingUserId = createSelector([getCandidateProfile], user => (user ? user.user_id : undefined))

export const loadingCandidate = createSelector([getCandidateProfile], user => !!user.loading)

export const locatedInEurope = createSelector([getCandidateProfile], ({ located_in_europe }) => located_in_europe)

export const regionCode = createSelector([getCandidateProfile], ({ region_code: code }) => code)

export const onboardingPhase = createSelector([getCandidateProfile], candidate => candidate.onboarding_phase)

export const candidateSlug = createSelector([getCandidateProfile], candidate => candidate.slug)
